export default __webpack_public_path__ + "static/media/banner-4.ba4699a2.jpg";